import { match as RouteMatch } from 'react-router-dom';

import React from 'react';
import { useAuthorPosts } from './hooks/useAuthorPosts';
import { useAppSelector } from 'hooks/redux';
import { Btn, PageMeta } from '../../components';
import AuthorPostsResults from './components/AuthorPostsResults/AuthorPostsResults';

import './AuthorPosts.css';
import {
  selectPosition7Banner,
  selectPosition8Banner,
  selectPosition9Banner,
} from 'store/ducks/banners/selectors';

export default function AuthorPosts({
  match,
}: {
  match: RouteMatch<{ author: string }>;
}) {
  const {
    title: titlePage,
    newsfeeds,
    paginate: newsfeedsPaginate,
    loadMore,
  } = useAuthorPosts(match.params.author);

  const position7Banner = useAppSelector(selectPosition7Banner);
  const position8Banner = useAppSelector(selectPosition8Banner);
  const position9Banner = useAppSelector(selectPosition9Banner);

  return (
    <>
      <PageMeta
        title={titlePage}
        description="Telesputnik.ru является одним из самых авторитетных и быстроразвивающихся интернет-порталов в области телевизионной индустрии, рынка OTT, медиапотребления и производства контента."
      />
      <main className="page page-newsfeed container container--page">
        <div className="page-newsfeed__header">
          <h1 className="page-title page-newsfeed__page-title">{titlePage}</h1>
        </div>
        <AuthorPostsResults
          newsfeeds={newsfeeds}
          position7Banner={position7Banner}
          position8Banner={position8Banner}
          position9Banner={position9Banner}
        />
        {newsfeedsPaginate &&
          newsfeedsPaginate.total_pages !== newsfeedsPaginate.current_page && (
            <Btn mod="" type="page-newsfeed" handleClick={loadMore}>
              Больше материалов
            </Btn>
          )}
        <div className="clear"></div>
        {/* <Media /> */}
      </main>
    </>
  );
}
